import {useCallback} from 'react';

import {useMutation} from '@tanstack/react-query';
import {useDispatch} from 'react-redux';

import {ENDPOINTS} from 'constants/endpoints';

import {AppThunkDispatchType} from 'desktop/store';

import {apiConfig} from 'libs/api/api';

import {getOrderReviewItems} from '../../store/reducers/orderReviewItems/orderReviewItems';
import {getOrderReviewTotals} from '../../store/reducers/orderReviewTotals/orderReviewTotals';

/**
 * Shipping protection remove, add logic
 */
export const useShippingProtectionActions = () => {
    const dispatch = useDispatch<AppThunkDispatchType>();
    const {isPending: isLoadingAddProtection, mutateAsync: addProtection} = useMutation({
        mutationFn: () =>
            apiConfig.instanceGusaBackend({
                data: {
                    enabled: true,
                },
                method: 'post',
                url: ENDPOINTS.SHIPPING_PROTECTION,
            }),
    });
    const {isPending: isLoadingRemoveProtection, mutateAsync: removeProtection} = useMutation({
        mutationFn: () =>
            apiConfig.instanceGusaBackend({
                data: {
                    enabled: false,
                },
                method: 'post',
                url: ENDPOINTS.SHIPPING_PROTECTION,
            }),
    });

    const refetchCheckoutSidebar = useCallback(() => {
        dispatch(getOrderReviewTotals({collectTax: false, withTaxErrors: false}));
        dispatch(getOrderReviewItems({collectTax: false, withTaxErrors: false}));
    }, [dispatch]);

    return {
        addProtection: useCallback(async () => {
            await addProtection();
            refetchCheckoutSidebar();
        }, [refetchCheckoutSidebar, addProtection]),
        isLoading: isLoadingRemoveProtection || isLoadingAddProtection,
        removeProtection: useCallback(async () => {
            await removeProtection();
            refetchCheckoutSidebar();
        }, [refetchCheckoutSidebar, removeProtection]),
    };
};
